import { createReducer } from 'redux-create-reducer'

// Custom action type for location changes in react-router-dom
export const ROUTER_LOCATION_CHANGE = '@@router/LOCATION_CHANGE'

export interface RouterLocation {
  pathname: string
  search: string
  hash: string
  state?: any
  key?: string
}

interface RouterState {
  location?: RouterLocation
  action?: string
}

type RouterHistoryState = RouterState & {
  history?: RouterLocation[]
  locationBeforeTransitions?: RouterLocation
}

const initialState: RouterHistoryState = {
  history: [],
}

const MAX_HISTORY_LENGTH = 10

export const routerHistoryReducer = createReducer<RouterHistoryState>(
  initialState,
  {
    [ROUTER_LOCATION_CHANGE](state, { payload }) {
      const { location, action } = payload

      return {
        ...state,
        location,
        action,
        locationBeforeTransitions: location,
        history: [...(state.history ?? []), location].slice(
          -MAX_HISTORY_LENGTH,
        ),
      }
    },
  },
) as any
